import { getUserRolesFromToken } from './settingsAccess';

export type JobBoardPermission = 'view' | 'manage';

export const hasJobBoardPermission = (
  token: string | null,
  permission: JobBoardPermission,
): boolean => {
  if (!token) return false;

  if (permission === 'view') return true;

  return getUserRolesFromToken(token).some((role) => {
    const normalizedRole = role.toLowerCase();
    return normalizedRole === 'admin' || normalizedRole === 'system';
  });
};
